var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLock = function SvgLock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M.75 14.002V4.813h1.969V3.501q0-1.36.96-2.321Q4.639.22 6 .22t2.322.96q.96.96.96 2.321v1.313h1.968v9.188zm3.281-9.188H7.97V3.501q0-.82-.574-1.394A1.9 1.9 0 0 0 6 1.533q-.82 0-1.395.574A1.9 1.9 0 0 0 4.031 3.5zM6 10.72q.54 0 .927-.385.386-.386.386-.927t-.386-.928A1.26 1.26 0 0 0 6 8.095q-.54 0-.927.385a1.26 1.26 0 0 0-.386.928q.001.54.386.927.386.385.927.385"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export default ForwardRef;